"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.developmentSubappBaseRender = exports.developmentSubappBaseFeatureLoader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ReactDOM = __importStar(require("react-dom"));
// providers
const providers_1 = require("./providers");
const featureFlag_1 = require("../../featureFlag");
const translations_1 = require("../../translations");
const developmentTools_1 = require("../../developmentTools");
const tracker_1 = require("../../tracker");
const renderUtils_1 = require("../utils/renderUtils");
const libraries_1 = require("../../libraries");
const initializer_1 = require("../../initializer");
/**
 * Wraps the app in the providers and mounts it directly into the DOM
 */
// eslint-disable-next-line complexity
const developmentSubappBaseFeatureLoader = async (params) => {
    if (params.trackerConfig) {
        await (0, tracker_1.initAllTrackers)(params.trackerConfig, initializer_1.API, initializer_1.GenericUSDManager, initializer_1.Authenticator);
        tracker_1.trackers.tealiumTracker && (0, tracker_1.addCommonInfoToTealiumTracker)(params.trackerConfig);
        tracker_1.trackers.wrapupTracker && (0, tracker_1.addCommonInfoToWrapupTracker)(params.trackerConfig);
    }
    await (0, libraries_1.initLibraries)(params.libraries);
    try {
        const initPromises = [];
        if (params.featureFlagConfig) {
            params.featureFlagConfig.isRequiredPublicFF
                ? initPromises.push((0, featureFlag_1.initFeatureFlagPublic)(params.featureFlagConfig, params.API))
                : initPromises.push((0, featureFlag_1.initFeatureFlag)(params.featureFlagConfig, params.API));
        }
        if (params.translationsConfig) {
            initPromises.push((0, translations_1.initConfigWebAndOwnTranslations)(params.API, params.translationsConfig));
        }
        await Promise.allSettled(initPromises);
    }
    catch {
        console.error('Can`t initiate feature flag or translations. Check network');
    }
};
exports.developmentSubappBaseFeatureLoader = developmentSubappBaseFeatureLoader;
const developmentSubappBaseRender = async (params) => {
    const AppWithProviders = () => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(developmentTools_1.DevelopmentModal, {}), (0, jsx_runtime_1.jsx)(providers_1.DevelopmentProviders, { routerType: params.routerType, loginComponent: params.loginComponent, drAgentLoginComponent: params.drAgentLoginComponent, children: (0, jsx_runtime_1.jsx)(params.app, {}) })] }));
    ReactDOM.render((0, jsx_runtime_1.jsx)(AppWithProviders, {}), (0, renderUtils_1.getRootElement)());
};
exports.developmentSubappBaseRender = developmentSubappBaseRender;
//# sourceMappingURL=index.js.map